import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconEmailCheck = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.91 19'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M22.903,11.001 C22.353,11.001 21.907,10.553 21.907,10.000 L21.907,3.564 L12.608,11.752 C12.420,11.918 12.186,12.001 11.951,12.001 C11.717,12.001 11.483,11.918 11.295,11.752 L1.995,3.564 L1.995,15.001 C1.995,15.552 2.442,16.001 2.991,16.001 L12.947,16.001 C13.497,16.001 13.943,16.448 13.943,17.001 C13.943,17.553 13.497,18.001 12.947,18.001 L2.991,18.001 C1.344,18.001 0.004,16.655 0.004,15.001 L0.004,3.000 C0.004,1.346 1.344,0.000 2.991,0.000 L20.912,0.000 C22.559,0.000 23.898,1.346 23.898,3.000 L23.898,10.000 C23.898,10.553 23.453,11.001 22.903,11.001 ZM11.951,9.671 L20.663,2.000 L3.240,2.000 L11.951,9.671 ZM16.688,14.348 L18.513,16.478 L22.157,12.338 C22.522,11.926 23.150,11.886 23.562,12.251 C23.974,12.617 24.013,13.249 23.649,13.663 L19.248,18.662 C19.059,18.877 18.787,19.000 18.502,19.000 C18.500,19.000 18.498,19.000 18.496,19.000 C18.208,18.998 17.936,18.871 17.748,18.652 L15.179,15.652 C14.820,15.233 14.868,14.602 15.284,14.242 C15.703,13.883 16.330,13.929 16.688,14.348 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconEmailCheck.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
